import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllRoles(page, size, search) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Role,
      queryString: `Page=${page}&Size=${size}&search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async updateRole(id, name) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Role,
    }, {
      Id: id,
      RoleName: name
    });
    return await firstValueFrom(observable);
  }

  async createRole(name) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Role
    }, {
      roleName: name
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }


}
